/*jshint esversion:6 */
import React from "react";
// import Select from "react-select";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Constants from "../../../configurations/constants";
import Permissions from "../../../configurations/permissions";
import ArbiterApi from "../../../api/ArbiterApi";
import MerchantDisputantsTable from "./merchantDisputantsTable";
import MerchantDisputantsModal from "./merchantDisputantsModal";
import FloatInput from "../../common/floatInput";

class MerchantDisputantsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      merchantDisputants: [],
      selectedMerchantDisputant: null,
      disputeRegions: [],
      searchData: [],
      disputeRegion: null,
      totalCount: 0,
      loading: false,
      loadingSearch: false,
      getDisputantsStatusCode : 0,
      statusCode: 0,
      domainCode: "",
      pages: 0,
      openModalFlag: false,
      createFlag: false,
      updateMerchant: false,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pageNum: 0, //Zero based index
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.onNewButtonClick = this.onNewButtonClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.paginateid = this.paginateid.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    // const idx = parseInt(index, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }
  componentDidMount() {
    //Load data on mount
    this.reloadDisputants();
  }

  onTextInputChange(event) {
    let stateUpdate = {};
    stateUpdate[event.target.id] = event.target.value;
    this.setState(stateUpdate);
  }
  onNewButtonClick(evt) {
    this.setState({ openModalFlag: true, createFlag: true });
  }
  handleFilterChange(evt) {
    this.setState({ disputeRegion: evt }, () => this.reloadDisputants());
  }
  handleSearch(evt) {
    this.setState({ loadingSearch: true });
    const domainCode = this.state.domainCode;
    ArbiterApi.getMerchantDisputant(domainCode)
      .then((response) => {
        this.setState({ loadingSearch: false });
        this.setState({ statusCode: response.status });
        this.setState({ searchData: response.data.content });
        this.setState({ domainCode: "" });
        if (response.data.content.length === 0)
          Toaster.warning("No merchant disputant record found");
      })
      .catch((error) => {
        Util.errorMessageToast(Toaster, error.data, [
          `${error.data ? error.data.description : error.statusText}`,
          `${Messages.ERROR_SEARCHING_MERCHANT_DISPUTE}`,
        ]);
        this.setState({ loadingSearch: false });
      });
  }
  render() {
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Merchant Disputants" />
        <Divider />

        <div className="row" style={{ marginRight: "0" }}>
          <div className="col-md-3">
            <FloatInput
              placeholder="Domain Code"
              id="domainCode"
              value={this.state.domainCode}
              onChange={this.onTextInputChange}
            />
          </div>
          <div className="col-md-2">
            <button
              id="searchButton"
              className="btn btn-primary btn-block"
              type="submit"
              onClick={(evt) => {
                this.handleSearch(evt);
              }}
              disabled={
                this.state.domainCode.length < 3 || this.state.loadingSearch
              }
            >
              Search
            </button>
          </div>
          <div className="mini-filter align-right">
            <button onClick={this.onNewButtonClick} className="btn btn-primary">
              + New Merchant Disputant
            </button>
          </div>
        </div>
        {this.state.statusCode === 200 && this.state.searchData.length > 0 ? (
          <MerchantDisputantsTable
            loading={this.state.loadingSearch}
            merchantDisputants={
              this.state.searchData
            }
            pageSize={
              this.state.statusCode === 200 ? this.state.searchData.length : 10
            }
            showPagination={false}
            table="searchTable"
            onRowClick={this.onRowClick}
          />
        ) : (
          <MerchantDisputantsTable
            onRowClick={this.onRowClick}
            loading={this.state.loading || this.state.loadingSearch}
            onTableChange={this.onTableChange}
            page={this.state.pageNum}
            pages={this.state.pages}
            defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
            merchantDisputants={this.state.merchantDisputants}
            paginatedCallBack={this.paginateid}
          />
        )}
        {this.state.openModalFlag && (
          <MerchantDisputantsModal
            isNew={this.state.createFlag}
            isOpen={this.state.openModalFlag}
            onRequestClose={this.handleCloseModal}
            merchantDisputant={this.state.selectedMerchantDisputant}
            updateMerchant={this.handleUpdateSearchMerchant}
          />
        )}
      </div>
    );
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.loadDisputants(params);
    }
  }

  loadDisputants(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;

    ArbiterApi.getMerchantDisputants(params)
      .then((response) => {
        let data = response.data.content;
        let totalCount = response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0)
          Toaster.warning("No records found.", "Merchant Disputants");
        this.setState({
          merchantDisputants: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages,
          
        });
      })
      .catch((error) => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_MERCHANT_DISPUTANTS}`,
        ]);
        this.setState({ loading: false });
      });
  }

  onRowClick(index) {
    this.setState({
      selectedMerchantDisputant:
        this.state.searchData.length > 0
          ? this.state.searchData[index]
          : this.state.merchantDisputants[index],
      openModalFlag: true,
      createFlag: false,
    });
  }
  handleCloseModal(event, reloadDataFlag, updateSearchedMerchant) {
    this.setState({
      selectedMerchantDisputant: null,
      openModalFlag: false,
      createFlag: false,
      updateMerchant: updateSearchedMerchant,
    });
    if (reloadDataFlag) {
      this.reloadDisputants();
    }
  }

  reloadDisputants() {
    this.setState({ merchantDisputants: [] });
    this.loadDisputants({ pageSize: this.state.pageSize });
    if (this.state.updateMerchant){
      this.setState({ searchData: [] });
      this.loadDisputants({pageSize : this.state.pageSize})
    } 
  
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(MerchantDisputantsPage, [Permissions.VIEW_TRANSACTION_TIMELINE])
);



// WEBPACK FOOTER //
// ./src/components/admin/merchantDisputants/merchantDisputantsPage.js